<template>
  <div class="kpi cx-card-height">
    <div class="head-box"> 
      <head-text  :kpi="Group"
                  :isSmall="isSmall">
      </head-text>

      <item :thresholdData="thresholdData" 
            :round="true" 
            :isSmall="isSmall"
            :kpi="Group">
      </item>
    </div>

    <div :class="{ 'thin-box-lg': !isSmall, 'thin-box-sml': isSmall }"> 
      <div  v-for="(item, index) in activeKpiItems" :key="index"
            class="thin-items">

        <head-text  :kpi="item" 
                    :left="true"
                    :isSmall="isSmall"
                    :saveRoom="true"
                    :isSecondary="true"
                    :isTranslucent="true">
        </head-text>
        <item :thresholdData="thresholdData" 
              :round="true" 
              :saveRoom="true"
              :isSmall="isSmall"
              :kpi="item">
        </item>

      </div>
    </div>
  </div>
</template>

<script>
import Cup from './KpiCup.vue';
import HeadText from './KpiHeader.vue';
import Item from './KpiItem.vue';
import Spacer from './KpiSpacer.vue';

export default {
  props: {
    actualTimeSetting: String,
    dashboardData: Object,
    groupName: String,
    thresholdData: Array,
    isSmall: { type: Boolean, default: false }
  },

  data() {
    return {
      kpiGroup: null,
      kpiGroupYTD: null,
      kpiItems: [],
      kpiItemsYTD: []
    };
  },

  components: {
    HeadText, Spacer, Cup, Item
  },
   
  mounted() {
    // init group and items
    this.kpiGroup = this.dashboardData.KPI.KPIGroup.find(x => x.Code == this.groupName);
    this.kpiGroupYTD = this.dashboardData.KPI.KPIGroupYTD.find(x => x.Code == this.groupName);
    this.kpiItems = this.dashboardData.KPI.KPI.filter(x => x.GroupCode == this.groupName);
    this.kpiItemsYTD = this.dashboardData.KPI.KPIYTD.filter(x => x.GroupCode == this.groupName);
    // debugger
  },

  computed: {
    activeKpiItems() {
      return this.actualTimeSetting == 'current'
        ? this.kpiItems
        : this.kpiItemsYTD;
    },

    Group() {
      let result = this.actualTimeSetting == 'current'
        ? this.kpiGroup
        : this.kpiGroupYTD;

      if (!result) {
        return { NameShort: this.groupName }
      }
      return result;
    }
  }
}
</script>

<style lang="scss" scoped>
  @use "@/../scss/bmw/cx.scss";

.head-box { 
  margin: 0.25rem;
}

.thin-box-lg {
  margin-top: 2.25rem;
}

.thin-box-sml {
  margin-top: 0rem;
}

.thin-items {
  margin: 0rem 0.5rem;
  padding: 0rem;
  border-radius: 0.25rem;
  border: 1px solid cx.$fg-color; //#eee;
}
</style>
